import { message } from "antd";
import orderService from "../services/orders/index1";

const nameSpace = "orders";

const initialState = {
  loading: {
    fetchList: false,
    fetch: false,
    updateStatus: false,
    create: false,
    reverse: false,
  },
  data: [],
  total: 0,
  limit: 10,
  error: null,
  currentOrder: null,
};

export const create = (data) => ({
  type: `${nameSpace}/create`,
  payload: data,
});

export const fetchList = (params) => ({
  type: `${nameSpace}/fetchList`,
  payload: params,
});

export const fetch = (id) => ({
  type: `${nameSpace}/fetch`,
  payload: id,
});

export const updateStatus = (id, status, driverId) => ({
  type: `${nameSpace}/updateStatus`,
  payload: { id, status, driverId },
});

export const reversePosOrder = (id, data) => ({
  type: `${nameSpace}/reversePosOrder`,
  payload: { id, data },
});

export const updateList = (id) => ({
  type: `${nameSpace}/updateList`,
  id,
});

export default {
  namespace: nameSpace,
  state: initialState,
  effects: {
    *updateList({ id }, { put }) {
      yield put({ type: "updateOrderStatus", payload: { id } });
    },
    *reversePosOrder({ payload }, { call, put }) {
      yield put({ type: "startLoading", loadingType: "reverse" });
      try {
        const response = yield call(
          orderService.updateStatus,
          payload.id,
          payload.data,
        );
        if (response.data) {
          message.success("Order reversed successfully");
        }
      } catch (error) {
        message.error(error.message);
      } finally {
        yield put({ type: "stopLoading", loadingType: "reverse" });
      }
    },
    *create({ payload }, { call, put }) {
      yield put({ type: "startLoading", loadingType: "create" });
      try {
        const response = yield call(orderService.create, payload);
        yield put({
          type: "setCurrentOrder",
          payload: response.data,
        });
        if (response.data) {
          message.success("Order placed successfully");
        }
      } catch (error) {
        message.error(error.message);
      } finally {
        yield put({ type: "stopLoading", loadingType: "create" });
      }
    },
    *updateStatus({ payload }, { call, put }) {
      if (payload.status !== "cancelled") {
        yield put({ type: "startLoading", loadingType: "updateStatus" });
      }

      try {
        const response = yield call(orderService.updateStatus, payload.id, {
          status: payload.status,
          shop_driver_id: payload.driverId,
        });
        yield put({
          type: "updateOrderStatus",
          payload: response.data,
        });
      } catch (error) {
        message.error(error.message);
      } finally {
        yield put({ type: "stopLoading", loadingType: "updateStatus" });
      }
    },
    *fetch({ payload }, { call, put }) {
      yield put({ type: "startLoading", loadingType: "fetch" });
      try {
        const response = yield call(orderService.fetch, payload);
        yield put({
          type: "addNewOrder",
          payload: response.data,
        });
      } catch (error) {
        message.error(error.message);
      } finally {
        yield put({ type: "stopLoading", loadingType: "fetch" });
      }
    },
    *fetchList({ payload }, { call, put }) {
      yield put({ type: "startLoading", loadingType: "fetchList" });
      try {
        const response = yield call(orderService.fetchList, payload);
        yield put({
          type: "setOrders",
          payload: { ...response.data, page: payload.page },
        });
      } catch (error) {
        yield put({ type: "setError", payload: error });
      } finally {
        yield put({ type: "stopLoading", loadingType: "fetchList" });
      }
    },
  },
  reducers: {
    setCurrentOrder(state, { payload }) {
      return { ...state, currentOrder: payload };
    },
    startLoading(state, { loadingType }) {
      return { ...state, loading: { ...state.loading, [loadingType]: true } };
    },
    stopLoading(state, { loadingType }) {
      return { ...state, loading: { ...state.loading, [loadingType]: false } };
    },
    setOrders(state, { payload }) {
      if (payload.page && payload.page > 1) {
        return {
          ...state,
          data: [...state.data, ...payload.list],
          total: payload.total,
        };
      } else {
        return {
          ...state,
          data: payload.list,
          total: payload.total,
        };
      }
    },
    addNewOrder(state, { payload }) {
      const exists = state.data.some((order) => order.id === payload.id);

      return {
        ...state,
        data: !exists
          ? payload.status === "confirmed"
            ? [...state.data, payload]
            : [payload, ...state.data]
          : state.data,
        total: !exists ? state.total + 1 : state.total,
      };
    },
    updateOrderStatus(state, { payload }) {
      return {
        ...state,
        data: state.data.filter((order) => order.id !== payload.id),
        total: state.total - 1,
      };
    },
    setError(state, { payload }) {
      return { ...state, error: payload };
    },
  },
};
